import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class EntityNotFound extends Component {
  static propTypes = {
    type: PropTypes.string,
    id: PropTypes.string
  };

  render() {
    const { type, id } = this.props;
    return (
      <div>
        <h1>Not Found</h1>
        <p>The {type} {id} does not exist.</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EntityNotFound.js